import TagManager from 'react-gtm-module'

export function processEvent({ event, data } = {}) {
  TagManager.dataLayer({
    dataLayer: {
      event,
      ...data
    }
  });
}

export function processPageView(state) {
  // gtm is configured to recognize and log history change triggers
  }

export function processConversionEvent({eventType, description} = {}) {}

  export function installAnalytics() {
    const propertyIdentifier = 'GTM-KH37MP9';
    const tagManagerArgs = {
        gtmId: propertyIdentifier,
        events: {
          startApp: 'Clicked on start App',
          scheduleAppointment: 'Clicked on Schedule an Appointment'
        }
    }
    console.log(`Installing and initializing google analytics: ${propertyIdentifier}`);
    TagManager.initialize(tagManagerArgs)
}
